module.exports = __webpack_public_path__ + "static/img/thumb_28.1a9edd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_28.png
// module id = boBX
// module chunks = 0